import React, { Component, useEffect, useState } from "react"
import PropTypes from "prop-types"
import axios from "axios"
import {
	Grid,
	Box,
	Typography,
	Button,
	Fade,
	Card,
	CardMedia,
	CardContent,
	Link,
	makeStyles,
} from "@material-ui/core/"
import Skeleton from "@material-ui/lab/Skeleton"
import Helmet from "react-helmet"

import { useTranslation, i18n } from "react-i18next"
import { Link as RouterLink } from "react-router-dom"

const useStyles = makeStyles((theme) => ({
	paper: {
		backgroundColor: "white",
		color: theme.palette.greenDark.main,
		position: "relative",
		zIndex: 2,
	},
	text: {
		color: theme.palette.greenDark.main,
	},
	avatar: {
		borderRadius: 100,
	},
	avatarBox: {
		marginTop: -30,
	},
}))
const BlogOverview = ({ blog, xs, sm }) => {
	const { t, i18n } = useTranslation()
	const classes = useStyles()
	const lang = i18n.language == "en" ? "" : "/nl"

	const blogBase = t("/blog")

	const [blogFields, setBlogFields] = useState({
		imgUrl: "",
		author: "",
		isLoaded: false,
		avatarUrl: "",
	})
	const { featured_media, author } = blog
	useEffect(() => {
		const getImageUrl = axios.get(
			`https://cms.footprintforest.nl/wp-json/wp/v2/media/${featured_media}`
		)
		const getAuthor = axios.get(
			`https://cms.footprintforest.nl/wp-json/wp/v2/users/${author}`
		)

		Promise.all([getImageUrl, getAuthor]).then((res) => {
			setBlogFields({
				imgUrl: res[0].data.media_details.sizes.medium.source_url,
				author: res[1].data.name,
				isLoaded: true,
				avatarUrl: res[1].data.avatar_urls,
			})
		})
	}, [])

	const blogdate = new Date(blog.date).toLocaleDateString("en-US")
	return (
		<Fade in={true}>
			<Grid item xs={xs} sm={sm}>
				<Card component="article" className={classes.paper}>
					<Box height={200}>
						{blogFields.imgUrl ? (
							<Fade in={true}>
								<CardMedia
									component="img"
									alt={blog.title.rendered}
									height={200}
									width="100%"
									image={blogFields.imgUrl}
									alt={blog.title.rendered}
								/>
							</Fade>
						) : (
							<Skeleton variant="rect" width="100%" height={200} />
						)}
					</Box>

					<CardContent>
						<Box className={classes.avatarBox} pb={2}>
							<img
								src={blogFields.avatarUrl[48]}
								className={classes.avatar}
								alt={blogFields.author}
								width="40px"
								height="40px"
							/>
							<Typography variant="overline" gutterBottom>
								{blogFields.author}
							</Typography>
						</Box>
						<Link
							style={{ textDecoration: "none", color: "black" }}
							component={RouterLink}
							to={lang + blogBase + "/" + blog.slug}
						>
							<Typography gutterBottom variant="h4" component="h2">
								{blog.title.rendered}
							</Typography>

							<Typography
								className={classes.postedon}
								variant="overline"
								gutterBottom
							>
								{t("blog.postedon")}{" "}
								<span className={classes.date}>{blogdate}</span>
							</Typography>
							<Typography
								variant="body1"
								component="p"
								dangerouslySetInnerHTML={{ __html: blog.excerpt.rendered }}
							></Typography>
						</Link>
						<Button
							variant="contained"
							to={blogBase + "/" + blog.slug}
							color="primary"
							component={RouterLink}
						>
							{t("blog.readmore")}
						</Button>
					</CardContent>
				</Card>
			</Grid>
		</Fade>
	)
}
export default BlogOverview
